import React, { useContext } from "react";
import { HeaderContext } from "../../../../../store/context/header-context";
import SVG_CHROME from "../../../../../assets/images/vector/Layout/Header/logos/chrome.svg";
import TrackedLink from "../../../../Analytics/TrackedLink";
import "./index.scss";

const Item = (props) => {
  const {
    title,
    subtitle,
    url,
    isBlank,
    action,
    label,
    category,
    onClickHandle,
    isLink,
    icon,
    logo,
  } = props;
  const { t } = useContext(HeaderContext);

  const onClick = () => {
    !isLink && onClickHandle && onClickHandle();
  };

  return isLink ? (
    <TrackedLink
      classes="GCL-H-E-I-L"
      path={url}
      target={isBlank}
      action={action}
      label={label}
      category={category}
    >
      <div className="GCL-H-E-I__title">{title}</div>
      <div className="GCL-H-E-I__subtitle">
        {subtitle}
        {logo === "chrome" && (
          <img src={SVG_CHROME} alt="" className="GCL-H-E-I__chrome" />
        )}
        {icon === "Hit" && <span className="GCL-H-E-I__hit">{t("Hit")}</span>}
      </div>
      <div className="GCL-H-E-I__line" />
    </TrackedLink>
  ) : (
    <div className="GCL-H-E-I-B" onClick={onClick}>
      <div className="GCL-H-E-I__title">{title}</div>
      <div className="GCL-H-E-I__subtitle">{subtitle}</div>
      <div className="GCL-H-E-I__line" />
    </div>
  );
};

export default Item;
